import { SocialName, SOCIAL_NETWORK } from "@cede/types";
import { DiscordStandardIcon, TelegramStandardIcon, XStandardIcon } from "@/components/icons";

export type SocialAccount = {
  id: SocialName;
  name: string;
  icon: React.ReactNode;
  usernamePrefix: string;
  autoLink?: boolean; // If true, the social account will be automatically linked when the user logs in, so no need to show the link/unlink button
};

export const SOCIALS: SocialAccount[] = [
  {
    id: SOCIAL_NETWORK.DISCORD,
    name: "Discord",
    icon: <DiscordStandardIcon />,
    usernamePrefix: "#",
  },
  {
    id: SOCIAL_NETWORK.X,
    name: "X - Twitter",
    icon: <XStandardIcon />,
    usernamePrefix: "@",
  },
  {
    id: SOCIAL_NETWORK.TELEGRAM,
    name: "Telegram",
    icon: <TelegramStandardIcon />,
    usernamePrefix: "@",
  },
  {
    id: SOCIAL_NETWORK.NATIVE_TELEGRAM,
    name: "Telegram",
    icon: <TelegramStandardIcon />,
    autoLink: true,
    usernamePrefix: "@",
  },
];
